import React, {Component} from 'react';
import {
    CleanFilterStyled,
    CloseButtonModalStyled,
    ContentCNPJBlock,
    ContentFilterSpaceStyled,
    ModalParent,
    ModalSuperParent
} from "../styled";
import {Typography} from "@material-ui/core";
import SpacerComponent
    from "../../../../Components/SpacerComponent/SpacerComponent";
import MessageUtil from "../../../../Utils/MessageUtil";
import LongTextFidelity from "../LongTextFidelity";
import CompanyService from "../../../../Services/CompanyService";
import {FidelityContext} from "../../../../Contexts/FidelityContext";
import CloseIcon from '@material-ui/icons/Close';
import TextFieldDefault
    from "../../../../Components/TextFieldDefaultComponent/TextFieldDefault";
import FormMask from "../../../../FromMask/FormMask";
import DeleteIcon from "@material-ui/icons/Delete";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import SearchIcon from "@material-ui/icons/Search";
import PaginationComponent
    from "../../../../Components/PaginationComponent/PaginationComponent";
import {TaxIdValidationUtil} from "../../../../Utils/TaxIdValidationUtil";

class ModalMoreBlockUserComponent extends Component {
    static contextType = FidelityContext;

    companyService

    constructor(props) {
        super(props);

        this.state = {
            data: null,
            blocked_user_allowed_company_invoices: null,
            blocked_user_allowed_company_invoices_cpf: null,
            filter: '',
            filterType: 'cpf',
        };

        this.companyService = new CompanyService();
    }

    componentDidMount() {
        this.load();
    }

    async load(page = 1) {
        try {

            this.context.parent.setState({
                inLoad: true,
            });

            const fidelityUuid = this.context.parent.state.isEditUuid;
            const filter = this.state.filter.replaceAll('_', '');

            const response = await this.companyService.getCpfs(fidelityUuid, page, filter);

            this.setState({
                data: response.data,
            });

            this.context.parent.setState({
                inLoad: false,
            });

        } catch (e) {
            this.context.parent.setState({
                inLoad: false,
                messagens: MessageUtil.make({
                    title: 'Atenção',
                    body: e,
                }),
            });
        }
    }

    async deleteCNPJCPFBlock(cpf, cnpj) {
        try {

            this.context.parent.setState({
                inLoad: true,
            });

            const fidelityUuid = this.context.parent.state.isEditUuid;
            await this.companyService.deleteCpfs(fidelityUuid, cpf, cnpj);

            this.context.parent.setState({
                inLoad: false,
                messagens: MessageUtil.make({
                    title: 'Sucesso',
                    body: 'Cadastro deletado',
                }),
            });

            this.load();

        } catch (e) {
            this.context.parent.setState({
                inLoad: false,
                messagens: MessageUtil.make({
                    title: 'Atenção',
                    body: e,
                }),
            });
        }
    }

    async addCNPJCPFBlock() {
        try {

            const cnpjValue = this.state.blocked_user_allowed_company_invoices;
            const cpfValue = this.state.blocked_user_allowed_company_invoices_cpf;

            if (!TaxIdValidationUtil.isValidCNPJ(cnpjValue)) {
                alert('CNPJ inválido');
                return;
            }

            if (!TaxIdValidationUtil.isValidCPF(cpfValue)) {
                alert('CPF inválido');
                return;
            }

            this.setState({
                blocked_user_allowed_company_invoices: '',
                blocked_user_allowed_company_invoices_cpf: '',
            });

            this.context.parent.setState({
                inLoad: true,
            });

            const fidelityUuid = this.context.parent.state.isEditUuid;
            await this.companyService.addCpfs(fidelityUuid, cpfValue, cnpjValue);

            this.context.parent.setState({
                inLoad: false,
                messagens: MessageUtil.make({
                    title: 'Sucesso',
                    body: 'Cadastro realizado',
                }),
            });

            this.load();

        } catch (e) {
            this.context.parent.setState({
                inLoad: false,
                messagens: MessageUtil.make({
                    title: 'Atenção',
                    body: e,
                }),
            });
        }
    }

    getMaskDynamic() {
        const cleanedString = this.state.filter.replace(/[^0-9]/g, '');

        console.log(cleanedString);
        if (cleanedString.length <= 11) {
            this.state.filterType = 'cpf';
            return FormMask.cpf + '9';
        }

        this.state.filterType = 'cnpj';
        return FormMask.cnpj;
    }

    doFilter() {
        this.load(1);
    }

    handleChange = (event) => {
        const {name, value} = event.target;
        this.setState({
            [name]: value,
        });
    }

    closeModal = () => {
        this.context.parent.load();
        this.props.showModalFunc();
    }

    cleanFilter = () => {
        this.state.filter = '';

        this.setState({
            filter: '',
        });

        this.load();
    }

    render() {
        if (!this.props.showModal) {
            return <></>;
        }

        return (
            <ModalSuperParent>
                <ModalParent>
                    <CloseButtonModalStyled onClick={this.closeModal}/>
                    <SpacerComponent height={20}/>
                    <Typography variant={"subtitle1"} color={'primary'}>CPF/CNPJ
                        de um programa de
                        fidelidade</Typography>
                    <SpacerComponent height={40}/>

                    <Typography variant={'subtitle1'}
                                color={'error'}>Notas com identificação do
                        consumidor (CNPJ), só poderão ser pontuadas
                        pelo
                        CPF associado,abaixo:</Typography>

                    <Typography variant={"subtitle1"}
                                color={'primary'}><b>Cadastrar</b></Typography>

                    <ContentCNPJBlock>
                        <TextFieldDefault
                            name={'blocked_user_allowed_company_invoices'}
                            onChange={(event) => this.handleChange(event)}
                            mask={FormMask.cnpj}
                            erros={this.props.erros}
                            label={'CNPJ'}
                            value={this.state.blocked_user_allowed_company_invoices}/>
                        <SpacerComponent width={20}/>
                        <TextFieldDefault
                            name={'blocked_user_allowed_company_invoices_cpf'}
                            onChange={(event) => this.handleChange(event)}
                            mask={FormMask.cpf}
                            erros={this.props.erros}
                            label={'CPF'}
                            value={this.state.blocked_user_allowed_company_invoices_cpf}/>
                        <SpacerComponent width={20}/>
                        <AddCircleOutlineIcon
                            onClick={() => this.addCNPJCPFBlock()}/>
                    </ContentCNPJBlock>

                    <ContentFilterSpaceStyled>
                        <Typography variant={"subtitle1"}
                                    color={'primary'}><b>Cadastrados</b></Typography>
                        <Typography variant={"subtitle2"}
                                    color={'primary'}>Filtros</Typography>
                        <ContentCNPJBlock>
                            <TextFieldDefault name={'filter'}
                                              onChange={(event) => this.handleChange(event)}
                                              mask={this.getMaskDynamic()}
                                              erros={this.props.erros}
                                              label={'Buscar CPF/CNPJ'}
                                              value={this.state.filter}/>
                            <SpacerComponent width={20}/>
                            <SearchIcon onClick={() => this.doFilter()}/>
                        </ContentCNPJBlock>

                        {this.state.filter &&
                            <CleanFilterStyled onClick={this.cleanFilter}>
                                <Typography variant={"caption"} color={'error'}>Limpar
                                    Filtros</Typography>
                            </CleanFilterStyled>
                        }

                        <SpacerComponent height={30}/>
                        <Typography variant={"subtitle2"}
                                    color={'primary'}>Resultados</Typography>

                        {this.state?.data?.data?.map((value, index) => {
                            return <ContentCNPJBlock>
                                <TextFieldDefault
                                    name={'blocked_user_allowed_company_invoices_dynamic'}
                                    onChange={(event) => this.handleChange(event)}
                                    mask={FormMask.cnpj}
                                    erros={this.props.erros}
                                    disabled={true}
                                    value={value.cnpj}/>
                                <SpacerComponent width={20}/>
                                <TextFieldDefault
                                    name={'blocked_user_allowed_company_invoices_dynamic'}
                                    onChange={(event) => this.handleChange(event)}
                                    mask={FormMask.cpf}
                                    erros={this.props.erros}
                                    disabled={true}
                                    value={value.cpf}/>
                                <SpacerComponent width={20}/>
                                <DeleteIcon
                                    onClick={() => this.deleteCNPJCPFBlock(value.cpf, value.cnpj)}/>
                            </ContentCNPJBlock>;
                        })}
                        <SpacerComponent height={30}/>
                        <PaginationComponent
                            total={parseInt(this.state?.data?.total)}
                            perPage={parseInt(this.state?.data?.per_page)}
                            currentPage={parseInt(this.state?.data?.current_page)}
                            itensVisible={2}
                            onChangePage={(page) => {
                                this.load(page);
                            }}/>
                    </ContentFilterSpaceStyled>
                </ModalParent>
            </ModalSuperParent>
        );
    }
}

export default ModalMoreBlockUserComponent;